import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { recommendationAccessorGetLocalizedProductBasePriceUnit } from '../../model'
import { recommendationGetFormattedPrice } from '../../recommendationGetFormattedPrice'

export const RecommendationProductPrice: FC<{
  product?: GkAirRecommendedProductDataWeb
}> = ({ product }) => {
  const { locale } = useGlobalConfigContext()
  const intl = useIntl()

  if (!product) {
    return (
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      <div className="min-h-[calc(var(--type-scale-l-line-height)+var(--type-scale-s-line-height)+var(--type-scale-s-line-height))]">
        <Skeleton className="mx-auto w-4/5" />
      </div>
    )
  }
  const { base_price_amount, price, reduced, strike_through_price } = product
  // Type-safe dynamic key access for unit
  const unit = recommendationAccessorGetLocalizedProductBasePriceUnit({
    locale,
    product,
  })

  return (
    <div className="flex flex-col">
      <span className="flex flex-col">
        <span
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="min-h-[var(--type-scale-s-line-height)] whitespace-nowrap text-dark-primary-strong line-through"
        >
          {reduced === 'true' &&
            strike_through_price !== null &&
            recommendationGetFormattedPrice({
              intl,
              price: strike_through_price,
            })}
        </span>

        {price ? (
          <span className="whitespace-nowrap text-2xl font-bold leading-l text-dark-brand">
            {recommendationGetFormattedPrice({
              intl,
              price,
            })}
          </span>
        ) : null}
      </span>
      {base_price_amount ? (
        // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
        <span className="min-h-[var(--type-scale-s-line-height)] text-s text-dark-primary-strong">
          {recommendationGetFormattedPrice({
            intl,
            price: base_price_amount,
            unit,
          })}
        </span>
      ) : null}
    </div>
  )
}
